// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container_3bqS9","status":"index_status_2v9AY","footer":"index_footer_XCnIW"};